export default __webpack_public_path__ + "8920d553004eabbf0dbcacf66c1219fa.png";